module.exports = __webpack_public_path__ + "img/studiosha_card.60767c5e.png";